module.exports = __webpack_public_path__ + "static/media/img-bg2.2a67a6de.png";